import React, { Component } from 'react';


class PlayPage extends Component {
    state = {
        currentWord: '',
        currentColor: 'white'
    }
    constructor(props) {
        super(props)
        this.myHeader = React.createRef();
    }

    async startRead(words) {
        for (let i = 0; i < words.length; i++) {
            this.setState({ currentWord: words[i] })
            if (words[i].includes(".") || words[i].includes("?") || words[i].includes("!")) {
                await this.delay(550);
            } else if (words[i].includes(",") || words[i].includes(":")) {
                await this.delay(400);
            } else if (words[i].length < 3) {
                await this.delay(200);
            } else {
                await this.delay(250);
            }
        }
        // this.setState({ currentWord: 'Done! 🎊' })

        await this.delay(4000);
        this.props.history.push('/')
        return;
    }

    async startMessage(words) {
        for (let i = 0; i < words.length; i++) {
            this.setState({ currentWord: words[i] })
            // Check if last word
            if (i < words.length && i > words.length - 2) {
                this.setState({ 'currentColor': "#059AE5" })
                await this.delay(1000);
                this.setState({ 'currentColor': "white" })
            } else {
                await this.delay(300);
            }
        }
        return;
    }

    async componentDidMount() {
        // await this.delay(400);
        var start = ["Are", "you", "ready?"];
        await this.startMessage(start);

        const words = this.props.location.state.words.split(" ");
        // const words = this.props.words.split(" ");

        await this.startRead(words);

    }
    // Delay function
    async delay(delayInms) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(2);
            }, delayInms);
        });
    }
    render() {
        const loaderStyle = {
            animation: 'loading 1.9s ease forwards'
        }

        let wordFieldStyle = {
            // marginTop: "-" + fieldHeight / 2 + "px",
            // marginLeft: "-" + fieldWidth / 2 + "px",
            color: "white"
        }
        wordFieldStyle['color'] = this.state.currentColor;
        // const node = this.myHeader.current;
        // if (node != null) {
        //     var fieldWidth = node.offsetWidth;
        //     var fieldHeight = node.offsetHeight;
        //     wordFieldStyle['marginTop'] = "-" + fieldHeight / 2 + "px";
        //     wordFieldStyle['marginLeft'] = "-" + fieldWidth / 2 + "px";
        // }

        return (
            <div className="play-page">
                <div className="play-page__loader" style={loaderStyle}></div>
                <h2 className="play-page__current-word"
                    ref={this.myHeader}
                    style={wordFieldStyle}
                >{this.state.currentWord}</h2>
            </div>

        );
    }
}


export default PlayPage;





// WEBPACK FOOTER //
// ./src/Components/PlayPage.jsx